export const SNACK_BAR_CLOSE_REASON = {
  CLICK_AWAY: 'clickaway',
};
